module.exports = __webpack_public_path__ + "img/Companycultrue-top.d52d3805.png";